import React from 'react';
import styled from 'styled-components';

import { HealtheraButton, colors } from '../../healtheraComponents';
import Note from '../Notes/Note';
import DetailsLine from './DetailsLine';

const PharmacyBriefDetails = ({ pharmacy, onNotesClick, lastNote, isLoading }) => {
  if (isLoading) {
    return <DetailsContainer>Loading...</DetailsContainer>;
  }

  if (!(pharmacy || isLoading)) {
    return <DetailsContainer>Pharmacy not found.</DetailsContainer>;
  }

  const { 
    address, 
    postcode, 
    country, 
    city, 
    pharmacy_contact, 
    pharmacy_email, 
    telephone 
  } = pharmacy || {};

  return (
    <DetailsContainer>
      <DetailsFieldSet>
        <DetailsTitle>Branch Address</DetailsTitle>
        <DetailsLine title="Address" value={address} />
        <DetailsLine title="City" value={city} />
        <DetailsLine title="Country" value={country} />
        <DetailsLine title="Postcode" value={postcode} />
      </DetailsFieldSet>
      <DetailsFieldSet>
        <DetailsTitle>Main Contact Person</DetailsTitle>
        <DetailsLine title="Name" value={pharmacy_contact} />
        <DetailsLine title="Email" value={pharmacy_email} />
        <DetailsLine title="Telephone" value={telephone} />
      </DetailsFieldSet>
      {lastNote && <Note title="Last note" small note={lastNote} />}
      <ButtonContainer>
        <HealtheraButton onClick={onNotesClick} height="34px" width="auto">
          {lastNote ? 'More notes' : 'Notes'}
        </HealtheraButton>
      </ButtonContainer>
    </DetailsContainer>
  );
};

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  background-color: ${colors.FADED_LIGHT};
  padding: 16px;
  font-family: 'SFProRegular';
  font-size: 16px;
`;

const DetailsTitle = styled.h3`
  margin: 0;
  margin-bottom: 20px;
  font-weight: 300;
`;

const DetailsFieldSet = styled.div`
  margin-bottom: 1rem;
`;

const ButtonContainer = styled.p`
  margin: 0;
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default PharmacyBriefDetails;
